import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "icon", "trigger"]
  static values = { expanded: { type: Boolean, default: false } }

  connect() {
    this.toggle(false)
  }

  toggle(animate = true) {
    this.expandedValue = !this.expandedValue
    
    if (animate) {
      this.contentTarget.style.transition = "max-height 0.3s ease-in-out, opacity 0.3s ease-in-out"
    }
    
    if (this.expandedValue) {
      this.contentTarget.style.maxHeight = this.contentTarget.scrollHeight + "px"
      this.contentTarget.style.opacity = "1"
      this.iconTarget.style.transform = "rotate(180deg)"
    } else {
      this.contentTarget.style.maxHeight = "0"
      this.contentTarget.style.opacity = "0"
      this.iconTarget.style.transform = "rotate(0deg)"
    }
  }
}